// projects/ui-shared/assets/i18n/*/common.json
export class CommonKey {
    public static buttonAdd = `button.add`;
    public static buttonBlock = `button.block`;
    public static buttonEdit = `button.edit`;
    public static buttonDelete = `button.delete`;
    public static buttonCopy = `button.copy`;
    public static buttonSave = `button.save`;
    public static buttonCancel = `button.cancel`;
    public static buttonClear = `button.clear`;
    public static buttonSearch = `button.search`;
    public static buttonAccept = `button.accept`;
    public static buttonAssign = `button.assign`;
    public static buttonSelect = `button.select`;
    public static buttonView = `button.view`;
    public static buttonInfo = `button.info`;
    public static pageTitleCardOptions = `commonPageTitle.cardOptions`;
    public static noRecordsFound = `noRecordsFound`;
    public static primeng = `primeng`;
    public static placeHolder = `placeHolder`;
    public static TRUE = `TRUE`;
    public static FALSE = `FALSE`;
    public static dropdownPlaceHolder = 'placeHolder';
}
